import { useDispatch, useSelector } from 'react-redux';
import { LOCATION_FILTER } from '../constants';
import './index.css';
import {
  getConversationsList,
  resetLocations,
  setLeftMenuOpen
} from '../../../redux/slices/communication';
import { useEffect, useRef, useState } from 'react';
import { searchForLocationsOnSlice } from '../../../redux/slices/location/locationsList';

import { useTranslate } from '@tolgee/react';
import ConversationListLoader from '../loaders/conversationListLoader';
import { useClickAway } from 'react-use';
import { LocationCard } from './locationCard';
import { Toaster } from 'react-hot-toast';

export default function LocationsList() {
  const containerRef = useRef(null);
  useClickAway(containerRef, () => {
    if (leftMenuOpen === LOCATION_FILTER) {
      setTimeout(() => {
        dispatch(setLeftMenuOpen(null));
      }, 150);
    }
  });
  const { isLoading, filtredLocations } = useSelector(
    (state) => state.locationsList
  );

  const { t } = useTranslate();

  const dispatch = useDispatch();

  const handleClick = (e) => {
    if (leftMenuOpen) dispatch(setLeftMenuOpen(null));
  };
  const componentName = LOCATION_FILTER;
  const {
    ui: { leftMenuOpen },
    data: { locations: locationsList }
  } = useSelector((state) => state.communication);

  const [position, setPosition] = useState('absolute');

  useEffect(() => {
    if (leftMenuOpen !== componentName) {
      // Start the animation, but delay the position change
      setTimeout(() => {
        setPosition('absolute');
      }, 150); // 500ms matches the longest transition time
    } else {
      // Set position immediately when showing the menu
      setPosition('static');
    }
  }, [leftMenuOpen]);

  //  if (leftMenuOpen !== componentName) return null;
  return (
    <>
      <div
        className="m-3 user-select-none"
        style={{ display: leftMenuOpen !== componentName ? 'none' : 'block' }}
      />
      <div
        style={{
          position: 'relative',
          minHeight: '100%'
        }}
        ref={containerRef}
      >
        <div
          className="small mb-4 h-100 overflow-scroll"
          style={{
            minHeight: '100%',
            opacity: leftMenuOpen !== componentName ? 0 : 1,
            width: leftMenuOpen !== componentName ? 0 : 300,
            visibility: leftMenuOpen !== componentName ? 'hidden' : 'visible',
            transform:
              leftMenuOpen !== componentName
                ? 'translateX(-80)'
                : 'translateX(0)',

            position,
            zIndex: 5,
            left: 20,

            transition:
              'transform 0.2s ease-out, width 0.2s ease-out, opacity 0.2s'
          }}
        >
          <div className="card p-3 d-flex  align-items-center position-relative h-100">
            <i
              className="fa-duotone fa-left-to-line position-absolute cursor-pointer"
              onClick={handleClick}
              style={{ right: 15, top: 15 }}
            ></i>
            <p className="fw-bold text-muted text-align-center mb-2 user-select-none">
              {t('communication.locationsList.pofile_groups')}
            </p>
            <input
              type="text"
              onChange={(e) =>
                dispatch(searchForLocationsOnSlice({ search: e.target.value }))
              }
              className="form-control form-control-lg"
              placeholder={t('communication.locationsList.search')}
            />
            <div className="mt-2" />
            <div className="d-flex w-100  flex-end align-items-center">
              <span
                className={`fw-bold ${
                  locationsList.length === 0
                    ? 'text-muted'
                    : 'text-primary cursor-pointer'
                }  m-2`}
                onClick={() => {
                  if (locationsList.length === 0) return;
                  dispatch(resetLocations());
                  dispatch(getConversationsList());
                }}
              >
                {t('communication.locationsList.deselect_all')}
              </span>
            </div>

            <div className="mt-2" />
            <div
              className="d-flex flex-column gap-5 w-100 h-100"
              style={{
                overflowY: 'auto',
                overflowX: 'hidden'
              }}
            >
              {isLoading ? (
                <ConversationListLoader />
              ) : (
                <>
                  {filtredLocations?.map((location) => (
                    <LocationCard location={location} key={location.uuid} />
                  ))}
                </>
              )}
              <div className="mt-5" />
            </div>
          </div>
        </div>
        <Toaster />
      </div>
    </>
  );
}
